import { combineCycles } from 'redux-cycles';
import * as cycles from './cycles';
import _ from 'lodash';

export default combineCycles(..._.map(cycles, cycle => cycle));
